import { render, staticRenderFns } from "./kpiPackages.vue?vue&type=template&id=77ff02f6&scoped=true"
import script from "./kpiPackages.vue?vue&type=script&lang=js"
export * from "./kpiPackages.vue?vue&type=script&lang=js"
import style0 from "./kpiPackages.vue?vue&type=style&index=0&id=77ff02f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff02f6",
  null
  
)

export default component.exports